module.exports = __webpack_public_path__ + "static/media/TR-808--mobile.cb15c560.svg";